import { schemeValidateApi } from '@/api';
import i18n from '@/lang';

export default {
  namespaced: false, //开启命名空间，更好的区分使用stage,防止不同stage模块中的方法重名
  state: {
    regionId: '',
    planInfo: {},
    projectConf: {},
    selectedMap: {},
    cartSelectedProd: {},
    totalCartCount: 0,
    prodTypeList: [],
    floorList: [],
    obstacles: [], //障碍物（墙体）
    curWall: null,
    activeTab: 1,
    filter: {
      name: i18n.t('home.byTimeNew'),
      value: 'false-createTime'
    },
    activeViewTab: 0,
    listMode: 'card',
    pageIndex: 1,
    pageSize: 20,
    gLoading: false,
    gWall: false,
    prodListSectionId: null,
    showAIWall: false,
    appUpdate: false,
    endAutoPlace: false, // 是否结束自动布点
    isCloudUser: false, // 是否网桥地勘体验用户
    autoPlaceing: '',
    fiberCheckRes: [], //分光器校验结果
    selectDeviceTabId: null, //设置选中的设备类型一级大类
    hightlightDevices: [], //高亮的设备
    areaCapacity: {},
    autoPlaceDevices: [],
    selectedMultipleAreas: [],
    editAreasStatus: 'selectDev', // 编辑用网需求状态 selectDev | vip | unplace | result
    areaAddPointLength: 0, //绘制区域，多少点计算
    actionNext: true, // 自动布点是否可以下一步
    selectedArea: null,
    hoverArea: null,
    selectedWalls: [],
    magnifyInfo: {},
    planActionType: 'choose',
    showEditArea: false,
    showOperateShape: false,
    showAreas: false, // 显示区域
    showWire: true, // 显示线缆，默认显示线缆
    globalAutoType: 'edit', // 自动识别类型，edit：专业布点，auto：自动布点
    selfAreaClear: false, // 是否清空数据
    actMask: false, // 编辑区域画布遮罩
    canEditAuto: true, // 自动布点是否可以编辑
    selectedFloorInfo: {}, // 选中楼层
    isAiWire: false, // 是否在自动布线
    drawWell: false, // 是否在添加弱电井
    drawDev: false, // 是否在添加设备
    drawBridge: false, // 是否在添加桥架
    drawTrunking: false, // 是否在添加线槽
    drawWire: false, // 是否在添加线材
    aiWireFinish: true, // AI布线是否结束
    aiWireLoading: false, // 是否在AI布线计算中
    aiWallScopeFinish: true, // AI识别外墙是否结束
    aiWallScopeLoading: false, // 是否在AI识别外墙中
    aiWireEndEnable: true, // AI布线end按钮
    wireOptions: [], // 全部线缆
    allWires: [], // 全部线缆数据
    legendWireData: [], // 线缆图例数据
    pickXiding: {
      id: '',
      pics: '',
      productName: ''
    }, // 布点吸顶选型
    pickMianban: {
      id: '',
      pics: '',
      productName: ''
    }, // 布点面板选型
    scalePlanView: false, // 是否设置比例尺过程中
    operateActiveTab: 1, // 工作台操作tab
    isAddDevice: false,
    isPlanSetting: false,
    isFloorSetting: false,
    topoActive: 1,
    canvasCanDrag: false,
    floorConf: null, // 楼层设置
    autoPlaceScene: null,
    curDrawWire: null, // 当前绘制线缆
    showApGuide: false,
    showBenchSystemGuide: false,
    showSelectAllGuide: false,
    showOneSelectAllGuide: false,
    legendFirstGuide: false,
    changeLegendFirstGuide: false,
    wireSaving: false,
    topoFirstGuide: false,
    showAdd6gDevGuide: false, // 控制6G仿真引导显示
    searchKeyDefault: '', //布点设计查询时默认关键字
    showDeepEmulation: true, // 控制高精度仿真按钮的显示
    originSimulatMode: 2,
    isDrawWalls: false, // 是否绘制墙
    wallsTypeList: [], //
    cameraPlace: {} // 存储摄像头布点时的tab数据
  },
  actions: {
    //光设备校验
    async checkFiberDevice({ commit }, params) {
      const {
        code,
        msg = '',
        data = {}
      } = await schemeValidateApi({
        body: {
          ...params
        }
      });
      if (code != 0) {
        return { success: false, msg };
      }
      commit('setFiberCheckRes', data);
    }
  },
  mutations: {
    setWireSaving(state, payload) {
      state.wireSaving = payload;
    },
    setTopoFirstGuide(state, data) {
      state.topoFirstGuide = data;
    },
    setLegendFirstGuide(state, data) {
      state.legendFirstGuide = data;
    },
    setChangeLegendFirstGuide(state, data) {
      state.changeLegendFirstGuide = data;
    },
    setShowOneSelectAllGuide(state, data) {
      state.showOneSelectAllGuide = data;
    },
    setShowSelectAllGuide(state, data) {
      state.showSelectAllGuide = data;
    },
    setShowBenchSystemGuide(state, data) {
      state.showBenchSystemGuide = data;
    },
    setCurDrawWire(state, data) {
      state.curDrawWire = data;
    },
    setShowApGuide(state, data) {
      state.showApGuide = data;
    },
    setFloorConf(state, data) {
      state.floorConf = data;
    },
    setCanvasCanDrag(state, data) {
      state.canvasCanDrag = data;
    },
    setTopoActive(state, data) {
      state.topoActive = data;
    },
    setIsPlanSetting(state, data) {
      state.isPlanSetting = data;
    },
    setIsFloorSetting(state, data) {
      state.isFloorSetting = data;
    },
    setIsAddDevice(state, data) {
      state.isAddDevice = data;
    },
    setScalePlanView(state, data) {
      state.scalePlanView = data;
    },
    setPickXiding(state, data) {
      state.pickXiding = data;
    },
    setPickMianban(state, data) {
      state.pickMianban = data;
    },
    setAutoPlaceScene(state, data) {
      state.autoPlaceScene = data;
    },
    setAllWires(state, data) {
      state.allWires = data;
    },
    setWireOptions(state, data) {
      state.wireOptions = data;
    },
    setAiWireLoading(state, data) {
      state.aiWireLoading = data;
    },
    setAiWireFinish(state, data) {
      state.aiWireFinish = data;
    },
    setAiWireEndEnable(state, data) {
      state.aiWireEndEnable = data;
    },
    setAiWallScopeLoading(state, data) {
      state.aiWallScopeLoading = data;
    },
    setAiWallScopeFinish(state, data) {
      state.aiWallScopeFinish = data;
    },
    setDrawWire(state, data) {
      state.drawWire = data;
    },
    setDrawWell(state, data) {
      state.drawWell = data;
    },
    setDrawDev(state, data) {
      state.drawDev = data;
    },
    setDrawBridge(state, data) {
      state.drawBridge = data;
    },
    setDrawTrunking(state, data) {
      state.drawTrunking = data;
    },
    setIsCloudUser(state, data) {
      state.isCloudUser = data;
    },
    setEndAutoPlace(state, data) {
      state.endAutoPlace = data;
    },
    setCanEditAuto(state, data) {
      state.canEditAuto = data;
    },
    setAppUpdate(state, data) {
      state.appUpdate = data;
    },
    setShowAIWall(state, data) {
      state.showAIWall = data;
    },
    setGWall(state, data) {
      state.gWall = data;
    },
    setGLoading(state, data) {
      state.gLoading = data;
    },
    setPageIndex(state, data) {
      state.pageIndex = data;
    },
    setPageSize(state, data) {
      state.pageSize = data;
    },
    setListMode(state, data) {
      state.listMode = data;
    },
    setActiveViewTab(state, data) {
      state.activeViewTab = data;
    },
    setHomeFilter(state, data) {
      state.filter = data;
    },
    setRegionId(state, data) {
      state.regionId = data;
    },
    setPlanInfo(state, data) {
      state.planInfo = data;
    },
    setHomeActiveTab(state, data) {
      state.activeTab = data;
    },
    setOperateActiveTab(state, data) {
      state.operateActiveTab = data;
    },
    setIsAiWire(state, data) {
      state.isAiWire = data;
    },
    setProjectConf(state, data) {
      state.projectConf = data;
    },
    setSelectedMap(state, data) {
      state.selectedMap = data;
    },
    setProdTypeList(state, data) {
      state.prodTypeList = data;
    },
    setFloorList(state, data) {
      state.floorList = data;
    },
    setSelectedFloorInfo(state, data) {
      state.selectedFloorInfo = data;
    },
    clearCartSelectedProd(state) {
      state.cartSelectedProd = {};
      state.totalCartCount = 0;
    },
    setProlistSection(state, data) {
      state.prodListSectionId = data;
    },
    setShowOperateShape(state, data) {
      state.showOperateShape = data;
    },
    setCartSelectedProd(state, data) {
      state.cartSelectedProd[`${data.source}_${data.id}_${data.catTag}`] = 1;

      let count = 0;

      for (const key in state.cartSelectedProd) {
        if (Object.hasOwnProperty.call(state.cartSelectedProd, key)) {
          const element = state.cartSelectedProd[key];
          count += element;
        }
      }

      state.totalCartCount = count;
    },
    updateCartSelectedProd(state, data) {
      if (data.type === 'add') {
        state.cartSelectedProd[`${data.source}_${data.id}_${data.catTag}`]++;
      } else if (data.type === 'del') {
        if (state.cartSelectedProd[`${data.source}_${data.id}_${data.catTag}`] > 0) {
          state.cartSelectedProd[`${data.source}_${data.id}_${data.catTag}`]--;
        } else {
          state.cartSelectedProd[`${data.source}_${data.id}_${data.catTag}`] = 0;
        }
      }

      let count = 0;

      for (const key in state.cartSelectedProd) {
        if (Object.hasOwnProperty.call(state.cartSelectedProd, key)) {
          const element = state.cartSelectedProd[key];
          count += element;
        }
      }

      state.totalCartCount = count;
    },
    setObstacles(state, data) {
      state.obstacles = data;
    },
    setCurWall(state, data) {
      let obstacle;
      obstacle = [...state.obstacles, ...state.wallsTypeList].find(item => {
        if (typeof data === 'string' && `${item.obstacleCode}${item.schemeObstacleId}` === data) {
          return true;
        } else {
          let { obstacleCode, schemeObstacleId } = data;
          return `${obstacleCode}${schemeObstacleId}` === `${item.obstacleCode}${item.schemeObstacleId}`;
        }
      });
      state.curWall = obstacle;
    },
    setAutoPlaceing(state, data) {
      state.autoPlaceing = data;
    },
    setAreaCapacity(state, data) {
      state.areaCapacity = data;
    },
    setAutoPlaceDevices(state, data) {
      state.autoPlaceDevices = data;
    },
    setFiberCheckRes(state, data) {
      state.fiberCheckRes = data;
    },
    setSelectTabAndDevices(state, data) {
      const { catTagId, hlDevices } = data;
      if (catTagId) {
        state.selectDeviceTabId = catTagId;
      }
      if (hlDevices) {
        state.hightlightDevices = hlDevices;
      }
    },
    clearHightDevAndTab(state) {
      state.selectDeviceTabId = null;
      state.hightlightDevices = [];
    },
    clearFiberCheck(state) {
      state.fiberCheckRes = [];
    },
    setShowEditArea(state, data) {
      state.showEditArea = data;
    },
    setSelectedMultipleAreas(state, data) {
      state.selectedMultipleAreas = data;
    },
    setEditAreasStatus(state, data) {
      state.editAreasStatus = data;
    },
    setActMask(state, payload) {
      state.actMask = payload;
    },
    setSelectedArea(state, data) {
      state.selectedArea = data;
    },
    setHoverArea(state, data) {
      state.hoverArea = data;
    },
    setSelectedWalls(state, data) {
      state.selectedWalls = data;
    },
    setMagnifyInfo(state, data) {
      state.magnifyInfo = { ...data };
    },
    setPlanActionType(state, data) {
      state.planActionType = data;
    },
    setAreaAddPointLength(state, data) {
      state.areaAddPointLength = data;
    },
    setGlobalAutoType(state, data) {
      state.globalAutoType = data;
    },
    setShowAreas(state, data) {
      state.showAreas = data;
    },
    setShowWire(state, data) {
      state.showWire = data;
    },
    setSelfAreaClear(state, data) {
      state.selfAreaClear = data;
    },
    setLegendWireData(state, data) {
      state.legendWireData = data;
    },
    setShowAdd6gDevGuide(state, data) {
      state.showAdd6gDevGuide = data;
    },
    setSearchKeyDefault(state, data) {
      state.searchKeyDefault = data;
    },
    setShowDeepEmulation(state, data) {
      state.showDeepEmulation = data;
    },
    setOriginSimulatMode(state, data) {
      state.originSimulatMode = data;
    },
    setIsDrawWalls(state, data) {
      state.isDrawWalls = data;
    },
    setWallsTypeList(state, data) {
      state.wallsTypeList = data;
    },
    setCameraPlace(state, data) {
      state.cameraPlace = data;
    }
  },
  getters: {
    regionId: state => state.regionId,
    planInfo: state => state.planInfo,
    projectConf: state => state.projectConf,
    selectedMap: state => state.selectedMap,
    cartSelectedProd: state => state.cartSelectedProd,
    totalCartCount: state => state.totalCartCount,
    prodTypeList: state => state.prodTypeList,
    floorList: state => state.floorList,
    obstacles: state => state.obstacles,
    curWall: state => state.curWall,
    activeTab: state => state.activeTab,
    filter: state => state.filter,
    activeViewTab: state => state.activeViewTab,
    prodListSectionId: state => state.prodListSectionId,
    listMode: state => state.listMode,
    pageIndex: state => state.pageIndex,
    gLoading: state => state.gLoading,
    gWall: state => state.gWall,
    showAIWall: state => state.showAIWall,
    appUpdate: state => state.appUpdate,
    endAutoPlace: state => state.endAutoPlace,
    pageSize: state => state.pageSize,
    autoPlaceing: state => state.autoPlaceing,
    fiberCheckRes: state => state.fiberCheckRes,
    selectDeviceTabId: state => state.selectDeviceTabId,
    hightlightDevices: state => state.hightlightDevices,
    estImage: state => state.estImage,
    isCloudUser: state => state.isCloudUser,
    autoPlaceDevices: state => state.autoPlaceDevices,
    areaCapacity: state => state.areaCapacity,
    showEditArea: state => state.showEditArea,
    selectedMultipleAreas: state => state.selectedMultipleAreas,
    editAreasStatus: state => state.editAreasStatus,
    areaAddPointLength: state => state.areaAddPointLength,
    actionNext: state => state.actionNext,
    selectedArea: state => state.selectedArea,
    hoverArea: state => state.hoverArea,
    selectedWalls: state => state.selectedWalls,
    magnifyInfo: state => state.magnifyInfo,
    planActionType: state => state.planActionType,
    showOperateShape: state => state.showOperateShape,
    numberAbnoramlIds: state => {
      const deviceIds = [];
      state.fiberCheckRes.forEach(item => {
        const { action, modifyProds = [] } = item;
        if (action != 2 || modifyProds.length == 0) return;
        modifyProds.forEach(it => {
          deviceIds.push(it.prodId);
        });
      });
      return deviceIds;
    },
    globalAutoType: state => state.globalAutoType,
    showAreas: state => state.showAreas,
    showWire: state => state.showWire,
    selfAreaClear: state => state.selfAreaClear,
    canEditAuto: state => state.canEditAuto,
    actMask: state => state.actMask,
    selectedFloorInfo: state => state.selectedFloorInfo,
    isAiWire: state => state.isAiWire,
    drawWell: state => state.drawWell,
    drawDev: state => state.drawDev,
    drawBridge: state => state.drawBridge,
    drawTrunking: state => state.drawTrunking,
    drawWire: state => state.drawWire,
    aiWireFinish: state => state.aiWireFinish,
    aiWireEndEnable: state => state.aiWireEndEnable,
    aiWireLoading: state => state.aiWireLoading,
    aiWallScopeFinish: state => state.aiWallScopeFinish,
    aiWallScopeLoading: state => state.aiWallScopeLoading,
    wireOptions: state => state.wireOptions,
    allWires: state => state.allWires,
    legendWireData: state => state.legendWireData,
    pickXiding: state => state.pickXiding,
    pickMianban: state => state.pickMianban,
    scalePlanView: state => state.scalePlanView,
    operateActiveTab: state => state.operateActiveTab,
    isAddDevice: state => state.isAddDevice,
    isPlanSetting: state => state.isPlanSetting,
    isFloorSetting: state => state.isFloorSetting,
    topoActive: state => state.topoActive,
    canvasCanDrag: state => state.canvasCanDrag,
    floorConf: state => state.floorConf,
    autoPlaceScene: state => state.autoPlaceScene,
    curDrawWire: state => state.curDrawWire,
    showApGuide: state => state.showApGuide,
    showBenchSystemGuide: state => state.showBenchSystemGuide,
    showSelectAllGuide: state => state.showSelectAllGuide,
    showOneSelectAllGuide: state => state.showOneSelectAllGuide,
    legendFirstGuide: state => state.legendFirstGuide,
    changeLegendFirstGuide: state => state.changeLegendFirstGuide,
    topoFirstGuide: state => state.topoFirstGuide,
    showAdd6gDevGuide: state => state.showAdd6gDevGuide,
    searchKeyDefault: state => state.searchKeyDefault,
    wireSaving: state => state.wireSaving,
    showDeepEmulation: state => state.showDeepEmulation,
    originSimulatMode: state => state.originSimulatMode,
    isDrawWalls: state => state.isDrawWalls,
    wallsTypeList: state => state.wallsTypeList,
    cameraPlace: state => state.cameraPlace
  }
};
